/* global $:true */

import debug from "debug";

const ELEMENT_SELECTOR = '[data-video-id],audio,video';
const MODULE_NAME = 'app.core/modules/video-blocks';
const log = debug(MODULE_NAME);


export function exec () {
	$(document).ready(() => {

		if($(ELEMENT_SELECTOR).length > 0) {
			System.import(
				/* webpackChunkName: "plyr-2.0.13" */ './plyr-2.0.13'
			).then((plyr) => {
				console.log('plyr', plyr);
				plyr.setup();
			});
		}
	});
}





// WEBPACK FOOTER //
// ./client/src/core/modules/video-blocks/index.js